module.exports = __webpack_public_path__ + "static/duze-1-99dc92b6dcf91648329fd49638fccad2.jpeg";